<template>
  <div ref="alert" class="background" v-if="status" :style="{ opacity: opacity }">
    {{ text }}
  </div>
</template>

<style lang="scss" scoped>
.background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  background: red;
  color: white;
  padding: 5px;
  transition: opacity 1s ease-out;
  z-index: 100000;
}
</style>

<script>
export default {
  props: { text: String, time: { type: Number, default: 5000 } },
  data: function () {
    return {
      status: false,
      opacity: 1,
    };
  },
  methods: {
    show: function () {
      this.status = true;
      this.opacity = 1;

      const _that = this;
      window.setTimeout(function () {
        _that.opacity = 0;
      }, this.time);

      this.$nextTick(function () {
        this.$refs.alert.addEventListener("transitionend", this.transition_end);
      });
    },
    transition_end: function () {
      this.status = false;
      this.$refs.alert.removeEventListener("transitionend", this.transition_end);
    },
  },
};
</script>
